import React, { useState } from "react";
import ShareBtn, { ShareBtnProps } from "../../../dynamic/ShareButton/src";

import "../../CircuitLandingPage/index.scss";
import "./heading.scss";
import { imgCrop, checkImage } from "../../../helpers";

interface link {
  title: string;
  linkURL: string;
  linkTarget: string;
  logoImage?: string;
}

interface Props {
  heading: string;
  subheading: string;
  hostNation: string;
  liveURL: string;
  streamURL: string;
  share: ShareBtnProps;
  surface: string;
  secondaryNav: link[];
  brandingLogoURL: string;
  backgroundImageURL?: imgCrop[];
  languages?: link[];
  quicklinks?: link[];
}

export default ({
  heading,
  subheading,
  hostNation,
  liveURL,
  streamURL,
  share,
  surface,
  secondaryNav,
  brandingLogoURL = "unset",
  backgroundImageURL,
  languages,
  quicklinks
}: Props) => {
  const [showMobileMenu, toggleMobileMenu] = useState(false);
  const pathnames = location.pathname.split("/").filter(f => f);

  return (
    <div>
      <section
        className="page-section itf-tour__nav-wrapper"
        style={{
          backgroundImage: `url("${checkImage({
            images: backgroundImageURL || [],
            size: "Large"
          })}")`
        }}
      >
        <div className="page-section__inner">
          <div
            className={`itf-tour__heading--tournament${
              languages && languages.length ? " lang" : ""
            }`}
          >
            <div className="itf-tour__heading-meta">
              <div className="itf-tour__wrapper">
                <div className="itf-tour__heading-title__wrapper">
                  <h1 className="itf-tour__heading-title">{heading}</h1>
                  <p className="itf-tour__subheading">{subheading}</p>
                </div>
                {languages && languages.length ? (
                  <ul className="itf-tour__heading-language__wrapper">
                    {languages.map((l: link) => (
                      <li>
                        <a
                          className="itf-tour__heading-language"
                          href={l.linkURL}
                          target={l.linkTarget}
                        >
                          {l.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
              <div
                className={`itf-tour__heading-links${
                  quicklinks && quicklinks.length ? " quicklinks" : ""
                }`}
              >
                <div className="itf-tour__heading-meta-value">
                  Host name: <span>{hostNation}</span>
                </div>
                {surface ? (
                  <div className="itf-tour__heading-meta-value">
                    Surface:{" "}
                    <span>
                      {surface}
                      <div className="tournament-hero__value tournament-hero__surface tournament-hero__surface--C surface" />
                    </span>
                  </div>
                ) : null}
                <div className="itf-tour__heading-meta-value buttons">
                  {share ? <ShareBtn {...share} /> : null}
                  {liveURL ? (
                    <a
                      className="itf-tour__heading-meta-value--live"
                      href={liveURL}
                    >
                      Live
                    </a>
                  ) : null}
                  {streamURL ? (
                    <a
                      className="itf-tour__heading-meta-value--watch"
                      href={streamURL}
                    />
                  ) : null}
                </div>
              </div>
            </div>
            {quicklinks && quicklinks.length ? (
              <ul
                className={`itf-tour__heading-quicklinks__wrapper itf-tour__heading-quicklinks__wrapper--length-${
                  quicklinks.length
                }${
                  pathnames[pathnames.length - 1] !== "home" ? " not-home" : ""
                }`}
              >
                {quicklinks.map(q => (
                  <li>
                    <a
                      className="itf-tour__heading-quicklinks"
                      href={q.linkURL}
                      target={q.linkTarget}
                    >
                      {q.logoImage ? (
                        <span
                          style={{
                            backgroundImage: `url("${q.logoImage}")`
                          }}
                          className="itf-tour__heading-quicklinks-icon"
                        />
                      ) : null}
                      <span className="itf-tour__heading-quicklinks-text">
                        {q.title}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
            <div
              className="itf-tour__logo"
              style={{
                backgroundImage: `url("${brandingLogoURL}")`,
                display: "flex"
              }}
            ></div>
          </div>
        </div>
      </section>
      <section className="page-section itf-tour__nav-secondary">
        <div className="page-section__inner">
          <ul className="itf-tour__nav--2">
            {secondaryNav.map(nav => (
              <li>
                <a
                  className={`item${
                    nav.linkURL.indexOf(location.pathname) >= 0 ? " active" : ""
                  } item--${nav.title.toLocaleLowerCase().split(" ")[0]}`}
                  target={nav.linkTarget}
                  href={nav.linkURL}
                >
                  {nav.title}
                </a>
              </li>
            ))}
            {secondaryNav.length > 3 ? (
              <li className="item item--more">
                <a
                  onClick={() => toggleMobileMenu(!showMobileMenu)}
                  className="item item--more"
                  href="javascript:void(0)"
                >
                  More
                </a>
              </li>
            ) : null}
          </ul>
        </div>
      </section>
      {secondaryNav.length > 3 ? (
        <div
          className={`itf-tour__mobile-menu-overlay${
            showMobileMenu ? " active" : ""
          }`}
        >
          <p>MORE</p>
          <span
            onClick={() => toggleMobileMenu(!showMobileMenu)}
            className="itf-tour__mobile-menu-overlay-close"
          />
          <ul>
            {secondaryNav.slice(3).map(nav => (
              <li>
                <a className="item" target={nav.linkTarget} href={nav.linkURL}>
                  {nav.title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};
